import React, { useRef } from 'react';
import { Space, Row, Col, Tooltip } from 'antd';
import TableFetchData from '../../components/data-table/TableFetchData';
import MagazineCard from '../../components/magazine/MagazineCard';
import EditTableSvg from '../../assets/images/EditTable';
import DeleteTableSvg from '../../assets/images/DeleteTable';
import { useTranslation } from 'react-i18next';
import MagazineModal from '../../components/magazine/MagazineModal';
import { ImageNo } from '../../components/image/ImageComponent';
import { formatDateTime } from '../../utils/dateFormatUtils';
import { useNavigate } from 'react-router-dom';
import { LuUpload } from "react-icons/lu";
import { sliceWord20character } from '../../utils/string';

const EducationCourseTabs = ({ 
  viewType, magazineData, tableParams,
   setTableParams, loading, setLoading,
   hadleUpdateMagazine, deleteMagazineData, 
   toggleView
}) => {
  const { t } = useTranslation();
  // new code for view pdf
  const magazineRef = useRef();
  const appDownloadRef = useRef();
  const navigate = useNavigate();
  const handleShowMagazine = async (item) => {
    magazineRef.current?.showModal(item);
  };
  const handleCloseDownloadApp = () => appDownloadRef.current?.closeModal();
  const maxLength = 20

  const tableSettings = {
    appendable: false,
    removable: false,
    bordered: true,
    size: "small",
    pagination: {
      showLessItems: true,
      pageSize: 10,
    },
    columns: [
      {
        title: <label className="titleCard14400">{t("Teacher Photo")}</label>,
        render: (_, record) => (
          <img onClick={() => toggleView(`${record._id}`)} style={{ width: "72px", height: "96px", borderRadius: "6px", objectFit: "cover", cursor:"pointer" }} src={record.picUrl || ImageNo} />
        )
      },
      {
        title: <label className="titleCard14400">{t("Teacher Name")}</label>,
        render: (_, record) => (
          <label className="text-capitalize">{record && record.name}</label>
        )
      },
      {
        title: <label className="titleCard14400">{t("introduce")}</label>,
        render: (_, record) => {
          return <Tooltip title={sliceWord20character(record && record.textIntro)}>
            {sliceWord20character(record && record.textIntro).length > maxLength ? sliceWord20character(record && record.textIntro).slice(0, maxLength) + "..." : sliceWord20character(record && record.textIntro)}
          </Tooltip>
        }
      },
      {
        title: <label className="titleCard14400">{t('Course Load')}</label>,
        render: (_, record) => (
          <a  onClick={() => toggleView(`${record._id}`)} className="text-capitalize">{record && record.courseCount}</a>
        )
      },
      {
        title: <label className="ant-table-column-title titleCard14400">{t('Creation Time')}</label>,
        dataIndex: 'createdTS',
        sorter: true,
        key: 'createdTS',
        render: (_, record) => (
          <label className="text-capitalize">{record && record.createdTS && formatDateTime(record.createdTS)}</label>
        )
      },
      
      {
        title: <label className="titleCard14400">{t('Create an account')}</label>,
        render: (_, record) => (
          <label className="text-capitalize">{record && record.createdBy && record?.createdBy?.name}</label>
        )
      },
      {
        title: <label className="titleCard14400">{t('Operator')}</label>,
        key: 'action',
        render: (_, record) => (
          <Space size="middle">
            <span style={{ cursor: "pointer" }} onClick={() => navigate(`/education-course/upload?id=${record._id}`)}>
              <LuUpload size={22} color="#636E88" style={{opacity:"0.8"}}/>
            </span>
            <span style={{ cursor: "pointer" }} onClick={() => navigate(`/education-teacher/upload/${record._id}`)}>
              <EditTableSvg />
            </span>
            <span style={{ cursor: "pointer" }} onClick={() => deleteMagazineData(record)}>
              <DeleteTableSvg />
            </span>
          </Space>
        ),
      },
    ],
  };

  return (
    <div>
      <Row gutter={16} align="middle" style={{ marginBottom: 16 }}>
        <Col style={{ marginLeft: 'auto' }}>
        </Col>
      </Row>

      {viewType === 'table' ? (
        <TableFetchData
          tableParams={tableParams}
          setTableParams={setTableParams}
          data={magazineData}
          columns={tableSettings.columns}
          loading={loading}
          setLoading={setLoading}
        />
      ) : (
        <MagazineCard 
          magazineData={magazineData} setLoading={setLoading} 
          loading={loading} tableParams={tableParams}
          tableSettings={tableSettings}
          setTableParams={setTableParams}
          hadleUpdateMagazine={hadleUpdateMagazine}
          deleteMagazineData={deleteMagazineData}
          handleShowMagazine={handleShowMagazine}
          navigate={navigate}
          t={t}
        />
      )}
      <MagazineModal
        ref={magazineRef}
        handleCloseDownloadApp={handleCloseDownloadApp}
      />
    </div>
  );
};

export default EducationCourseTabs;
